import React from "react";
import "./index.css";

class NewPage extends React.Component {
  render() {
    return (
      <div className="select-report-back">
        <h3>Select node from the left menu to continue...</h3>
      </div>
    );
  }
}

export default NewPage;

// import React from "react";

// import {
//   Dialog,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from "@material-ui/core";
// import InfoIcon from "@material-ui/icons/Info";
// import "./index.css";

// export default function NewPage() {

//   return (
//     <React.Fragment>

//       <Dialog
//         open
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//          className="no-report-select-dialog"
//       >
//         <DialogTitle id="alert-dialog-title">
//           <div><InfoIcon /></div>
//           {"No Report Selected"}
//         </DialogTitle>

//         <DialogContent className="alert-inner-container">
//           <DialogContentText id="alert-dialog-description">
//             Please select a report from the left menu to continue...
//           </DialogContentText>
//         </DialogContent>
//       </Dialog>
//     </React.Fragment>
//   );
// }




// WEBPACK FOOTER //
// src/modules/employee/NewPage/index.js